// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

type BugReportListener = () => void;
const bugReportListeners = new Set<BugReportListener>();

/**
 * Subscribe to bug-report open requests. The bug-report modal lives in
 * RootLayoutNav, so screens that render without the global header (e.g. the tour
 * editor) cannot reach its state directly — they call requestBugReport instead.
 */
export function subscribeBugReportRequest(listener: BugReportListener): () => void {
  bugReportListeners.add(listener);
  return () => {
    bugReportListeners.delete(listener);
  };
}

export function requestBugReport() {
  bugReportListeners.forEach((listener) => {
    listener();
  });
}
